import { API, Auth } from 'aws-amplify';
import { API_GATEWAY_NAME } from '../constants/BackendConstants';

export async function callApigateway({ endpoint, method = 'GET', body = null }) {
    try {
        const session = await Auth.currentSession();
        const accessToken = session.getAccessToken().getJwtToken();
        const result = await API[method.toLowerCase()](API_GATEWAY_NAME, endpoint, {
            body,
            headers: {
                'Authorization': accessToken
              }
        });
        return result;
    } catch (err) {
        throw err;
    }
}
